// extracted by mini-css-extract-plugin
export default {"common":"styles_common__vJsA6","details":"styles_details__Gi35l","moves":"styles_moves__JJ6DT"};